import { RewistaTobaccoService } from './rewistaTobaccoService';
import { ProblemDTO, ErrorHeader, ErrorResolution, RefreshResult } from '@/customTypes';
import { AxiosResponse } from 'axios';

export default class ProblemService extends RewistaTobaccoService {
    public async getProblems(): Promise<ProblemDTO[]> {
        const response = await this.axiosProblemsRequest();
        if (response.status !== 200) {
            return new Array<ProblemDTO>();
        }
        return response.data;
    }

    public async resolveUserProblems(errors: ErrorHeader[]): Promise<ErrorResolution[]> {
        const response = await this.axiosResolveUserProblems(errors);
        if (response.status !== 200) {

            const ds = errors.map<ErrorResolution>((a) => ({error: a,
            result: ({resolved: false}) as RefreshResult }) as ErrorResolution );
        }
        return response.data;
    }

    private async axiosProblemsRequest(): Promise<AxiosResponse<ProblemDTO[]>> {
        return await this.axios.get<ProblemDTO[]>('Problem/GetProblems');
    }
    private async axiosResolveUserProblems(errors: ErrorHeader[]): Promise<AxiosResponse<ErrorResolution[]>> {
        return await this.axios.post<ErrorResolution[]>('Problem/ResolveUserProblems', errors);
    }
}
